
export type GetChatThreadById200ParticipantsItem = {
  /**
   * User avatar URL
   * @nullable
   */
  avatarUrl?: string | null;
  /** User display name */
  displayName: string;
  /** Participant user ID (same as userId for compatibility) */
  id: string;
  /** User name (alias for displayName) */
  name?: string;
  /** User ID */
  userId: string;
  /**
   * Preferred username/handle
   * @nullable
   */
  userName?: string | null;
};
